<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center column v-if="error">
      <v-flex>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <app-loading v-if="loading"></app-loading>
    <v-layout v-else justify-center>
      <v-flex xs12 sm8 md8>
        <v-card class="mb-6">
            <v-toolbar color="success" dark>
              <v-toolbar-title>Bookings</v-toolbar-title>
              <v-spacer></v-spacer>
              <create-order></create-order>
          </v-toolbar>
          <v-card-text>

            <v-tabs
                v-model="tab"
                centered>
              <!--                  <v-tabs-slider style="background-color: #023765"></v-tabs-slider>-->
              <v-tabs-slider style="background:linear-gradient(135deg, #0badeb 0%,#0470dc 100%);"></v-tabs-slider>
              <v-tab
                  v-for="item in tabItems"
                  :key="item"
              >
                {{ item }}
              </v-tab>

            </v-tabs>
            <v-divider></v-divider>
<!--orders-->
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-list two-line v-if="orders">
                  <template v-for="sale in orders">
                    <v-list-item
                        :key="sale.id"
                        router
                        :to="'/booking/'+ sale.id"
                    >

<!--                      <v-list-item-content  v-if="sale.created">-->
<!--                        <v-list-item-title-->
<!--                            class="font-weight-bold">-->
<!--                          <div>{{sale.created}}</div>-->
<!--                          <div v-if="!sale.label">{{sale.lineItems[0].title}}</div>-->
<!--                          <div v-else>{{sale.label}}</div>-->
<!--                          &lt;!&ndash;                          <div class="font-weight-light" v-if="sale.clientInfo">{{sale.clientInfo.name}}</div>&ndash;&gt;-->
<!--                        </v-list-item-title>-->
<!--                        <v-list-item-title>{{moment(sale.created)}}</v-list-item-title>-->
<!--                      </v-list-item-content>-->

                      <v-list-item-content>
                        <v-list-item-title
                            v-if="sale.lineItems[0]"
                            class="font-weight-bold">
                          <div v-if="!sale.label">{{sale.lineItems[0].title}}</div>
                          <div v-else>{{sale.label}}</div>
                          <div class="font-weight-light" v-if="sale.clientInfo">{{sale.clientInfo.name}} ID: {{sale.id}}</div>
                        </v-list-item-title>
                        <v-list-item-title>
<!--                          {{sale.fulfillmentInfo.date}}-->
                          {{momentDate(sale.fulfillmentInfo.date)}}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action v-if="sale.status == 'fulfilled'">
                        <v-icon>check</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list>
              </v-tab-item>
<!--     quotes-->
              <v-tab-item>
                <v-list two-line v-if="quotes">
                  <template v-for="(sale) in quotes">
                    <v-list-item
                        :key="sale.created"
                        router
                        :to="'/quote/'+ sale.id + '/' + sale.clientInfo.activeListingId"
                    >

                      <v-list-item-content  v-if="sale.lineItems">
                        <v-list-item-title
                            class="font-weight-bold">
                          <div v-if="!sale.label">{{sale.lineItems[0].title}}</div>
                          <div v-else>{{sale.label}}</div>
                          <div class="font-weight-light" v-if="sale.clientInfo">{{sale.clientInfo.name}}</div>
                        </v-list-item-title>
                        <v-list-item-title>{{moment(sale.created)}}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action v-if="sale.status == 'fulfilled'">
                        <v-icon>check</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
        <div class="text-center">
          <v-btn @click="fetchNext" class="blue--text" outlined>load more</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import {collection, query, orderBy, limit, getDocs, startAfter} from "firebase/firestore";
    export default {
        data () {
            return {
              tab: 0,
              tabItems: [
                'Orders', 'Quotes'
              ],
              itemFound: null,
              lastDoc: null,
              pageInit: 1,
              orders: null,
              quotes: null,
              lastQuoteDoc: null
            }
        },
      computed: {
        msgNotValid () {
          if (this.textMessage !== '') {
            return false
          } else return true
        },
        moment () {
          return (date) => {
            let day = moment(date).format('ddd, MMM Do, hh:mm A')
            return day
          }
        },
        momentDate () {
          return (date) => {
            let day = moment(date).format('dddd, LL')
            return day
          }
        },
        error () {
          return this.$store.getters.error
        },
        loading () {
          return this.$store.getters.loading
        },
        user () {
          return this.$store.getters.user
        }
      },
      created() {
        let db = this.$store.state.db
        let salesRef = collection(db, 'users', this.user.uid + '/orders')
        let ordersQuerry = query(salesRef, orderBy('created', "desc"), limit(25))

        let quotesRef = collection(db, 'users', this.user.uid + '/quotes')
        let quoteQuerry = query(quotesRef, orderBy('created', "desc"), limit(25))


        //611ca180-aaba-11ef-9482-eb03c9995103
        //54bc0840-a2a4-11ef-8c54-575da0ff3eac

        // b29b72b0-d806-11ef-9ffb-a12958a84c95
        //
        getDocs(ordersQuerry)
            .then(res => {
              let orders = []
              if(!res.empty) {
                res.forEach(doc => {
                  let data = doc.data()
                  data.id = doc.id
                  orders.push(data)
                })
                this.orders = orders
                // console.log(this.orders)
                this.lastDoc = orders[res.docs.length-1]
              }
              return getDocs(quoteQuerry)
            })
            .then((quoteData) => {
              let quotes = []
              if(!quoteData.empty) {
                quoteData.forEach(doc => {
                  quotes.push(doc.data())
                })
                this.quotes = quotes
                // console.log(this.quotes)
                this.lastQuoteDoc = quotes[quoteData.docs.length-1]
                this.$store.dispatch('setLoading', false)
              }
            })
      },
      methods: {
        onDismissed () {
          this.$store.dispatch('clearError')
        },
        fetchNextQuotes () {
          let db = this.$store.state.db
          let lastDoc = this.lastDoc
          let salesRef = collection(db, 'users', this.user.uid + '/orders')
          let q = query(salesRef, orderBy('created', 'desc'), startAfter(lastDoc['created']), limit(25))
          getDocs(q)
              .then(res => {
                //console.log(res)
                if (res && res.empty !== true) {
                  let orders = []
                  res.docs.forEach(doc => {
                    let data = doc.data()
                    orders.push(data)
                    this.orders.push(data)
                  })
                  this.lastQuoteDoc = orders[res.docs.length-1]
                }
              })
        },
        fetchNext() {
          let db = this.$store.state.db
          let lastDoc = this.lastDoc
          let salesRef = collection(db, 'users', this.user.uid + '/orders')
          let q = query(salesRef, orderBy('created', 'desc'), startAfter(lastDoc['created']), limit(25))
            getDocs(q)
            .then(res => {
              //console.log(res)
              if (res && res.empty !== true) {
                let orders = []
                res.docs.forEach(doc => {
                  let data = doc.data()
                  orders.push(data)
                  this.orders.push(data)
                })
                this.lastDoc = orders[res.docs.length-1]
              }
            })
        }
      }
    }
</script>
